module.exports = __webpack_public_path__ + "static/media/builtinv2-kak-pravilno-vybrat-perforator-dlia-remonta.22bd0432.png";